export const Bio = {
  name: "Champa Lal Suthar",
  roles: [
    "Software Engineer",
    "Full Stack Developer",
    "Programmer"
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/champalalsuthar",
  resume: "https://drive.google.com/file/d/1s4B4uB9sHFyWF85EwgXkDR3ipptHMMKR/view?usp=drive_link",
  // resume:"https://firebasestorage.googleapis.com/v0/b/portfolio-14cb1.appspot.com/o/champa_s_resume%20(17).pdf?alt=media&token=ea23c03c-9405-40c0-b06a-9bc95ba8119c",
  linkedin: "https://www.linkedin.com/in/champa-lal-suthar-325040253/",
  twitter: "https://www.twitter.com/",
  insta: "https://www.instagram.com/",
  facebook: "https://www.facebook.com/",
  leetcode: "https://leetcode.com/champa_lal/",
};

export const skills = [
  {
    title: "Programming Languages",
    skills: [

      {
        name: "C",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQuAp3hUUgofO1GtgLuBS19KEZTczl610YQmPEpWm1kxw&s",
      },
      {
        name: "C++",
        image:
          "https://w7.pngwing.com/pngs/46/626/png-transparent-c-logo-the-c-programming-language-computer-icons-computer-programming-source-code-programming-miscellaneous-template-blue.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
    ],
  },
  {
    title: "Framework & Library",
    skills: [
      {
        name: "React.js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "React Native",
        image:
          "https://img.icons8.com/?size=100&id=58811&format=png&color=000000"
      },
      {
        name: "Node.js",
        image: "https://nodejs.org/static/images/logo.svg",
      },

      {
        name: "Next.js",
        image: "https://raw.githubusercontent.com/riodel27/nextjs-template/main/nextjs-logo.ico",
      },



      {
        name: "Express.js",
        image: "data:image/png;base64,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",
      },
      {
        name: "Redux",
        image: "https://raw.githubusercontent.com/reduxjs/redux/master/logo/logo.svg",
      },

      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Tailwind",
        image:
          "https://w7.pngwing.com/pngs/293/485/png-transparent-tailwind-css-hd-logo-thumbnail.png",
      },
    ],
  },
  {
    title: "Developer Tools",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "AWS (EC2, S3)",
        image:
          "https://www.logo.wine/a/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.svg",
      },
      {
        name: "WinSCP)",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwSwBP2q3s-o6Nluyuf-j6gz3LGg1vATpBwQ&s",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      // {
      //   name: "Netlify",
      //   image:
      //     "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      // },
      {
        name: "Vercel",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkSbYjTKHvJIvKlfaEFMPesv_sdhXRnVzbDRQqJyfU5A&s",
      },

      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
    ],
  },

];

// export const experiences = [
//   {
//     id: 0,
//     img: "",
//     role: "MERN DEVELOPER",
//     company: "KODE KLAN PRIVATE LIMITED",
//     date: "01-08-2024",
//     desc: "",
//     skills: [
//       "ReactJS",
//       "Redux",
//       "NodeJs",
//       "Material UI",
//       "HTML",
//       "CSS",
//       "JavaScript",
//     ],
//     doc: "",
//   },
//   // {
//   //   id: 0,
//   //   img:  "",
//   //   role:  "",
//   //   company: "",
//   //   date: "",
//   //   desc:  "",
//   // },
// ];

export const experiences = [
  {
    id: 0,
    img: "", // Add image URL if needed
    role: "Full Stack Developer (Assistant System Engineer L2)",
    company: "CAPSITECH IT SERVICES PVT. LTD., Jodhpur (Raj.)",
    date: "Nov 2025 - Present",
    desc: "Developed a dynamic resume builder module with customizable templates, improving user profile visibility and engagement, Built scalable backend APIs using Express.js ensuring secure data handling and high performance, Implemented PDF / Word export and shareable profile links used by 1000+ users,Improved system maintainability by writing modular and reusable code",
    skills: [
      "Next.JS",
      "TypeScript",
      "TanStack Query",
      "Redux",
      "Node.Js",
      "Express.Js",
      "MongoDB",
    ],
    doc: "", // Add any documentation URL if needed
  },
  {
    id: 1,
    img: "", // Add image URL if needed
    role: "SOFTWARE ENGINEER",
    company: "Kode Klan Private Limited,Noida (U.P.)",
    date: "August 2024 - October 2025",
    desc: "Working as a MERN Developer, responsible for developing and maintaining web applications using the MERN stack. Engaged in frontend development with ReactJS, managing application state with Redux, and building backend APIs with NodeJs.",
    skills: [
      "React.Js",
      "React Native",
      "Redux",
      "Node.Js",
      "Express.Js",
      "JavaScript",
      "MongoDB",
      "AWS(EC2,S3)",
      "WinSCP",
      "HTML",
      "CSS",
      "Tailwind",
      "Material UI",
      "Git",
      "GitHub",
    ],
    doc: "", // Add any documentation URL if needed
  },
  {
    id: 2,
    img: "", // Add image URL if needed
    role: "Software developer intern",
    company: "ECHIOFY Private Limited,Noida (U.P.)",
    date: "Feb 2024 - July 2024",
    desc: "Worked as a Software developer Intern, assisting in the development of web applications using both frontend and backend technologies.",
    skills: [
      "React.Js",
      "Node.Js",
      "Express.Js",
      "JavaScript",
      "HTML",
      "CSS",
      "Tailwind"
    ],
    doc: "", // Add any documentation URL if needed
  },
];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/f/fd/Central_University_of_Haryana_logo.png",
    school: "Central University of Haryana",
    date: "Nov 2022 - May 2024",
    grade: "8.38 CGPA",
    desc: "I have completed my Master of Computer Application degree at Central University of Haryana. I have successfully finished all 4 semesters and achieved a CGPA of 8.38",
    degree: "Master of Computer Application, Computer Science and Information Technology",
  },
  {
    id: 1,
    img: "https://png.pngtree.com/png-vector/20201127/ourmid/pngtree-nanchang-university-administration-building-png-image_2443520.jpg",
    school: "Government PG College Barmer",
    date: "July 2019 - May 2022",
    grade: "60.44%",
    desc: "I completed my Gradation's degree at Government PG College Barmer.",
    degree: "Bachelor of Science",
  },
  {
    id: 2,
    img: "https://img.lovepik.com/element/45000/6636.png_860.png",
    school: "Shastri Bal Niketan Sr. Sec. School, Sikar",
    date: "July 2017 - May 2019",
    grade: "79.40%",
    desc: "I completed my high school education at Shastri Bal Niketan Sr. Sec. School, Sikar,where I studied Mathematics Physics and Chemistry.",
    degree: "CLASS-XII, PCM",
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8EnFMfxIS18DpQF8RNQahEj2kIfM6wHEbMg&usqp=CAU",
    school: "Maharaja Public Sr. Sec. School, Barmer ",
    date: "July 2016 - May 2017",
    grade: "81.17%",
    desc: "I completed my class 10 education at Maharaja Public Sr. Sec. School, Barmer.",
    degree: "CLASS-X",
  },
];

export const projects = [
  {
    id: 0,
    title: "WorkMate App",
    // date: "Jan 2025",
    description:
      "Built a mobile application for **WorkMate**, a SaaS platform designed to streamline employee attendance and leave management. The app enables employees to check in and out using facial recognition and GPS, increasing attendance accuracy by 40%. The user-friendly interface ensures easy access to attendance history and leave requests. This app is built with security in mind, using JWT-based authentication and bcrypt hashing for user data protection.",
    image: require("./image5.png"),
    tags: ["React Native", "Redux", "Node.js", "Express.js", "MongoDB"],
    category: "Mobile App",
    github: "https://github.com/champalalsuthar/EMP-APP-FRONTEND",
    webapp: "https://work-mate-landing-page.vercel.app/",
    Is_Live: true,
  },
  {
    id: 1,
    title: "WorkMate Admin Panel",
    // date: "Jan 2025",
    description:
      "Developed a comprehensive admin panel for **WorkMate**, a SaaS platform built to manage employee operations across organizations. The admin panel supports multiple roles: Super Admin, Admin, and HR. Features include managing employee attendance, leave requests, team performance, and detailed analytics for operational improvements. With secure JWT authentication and role-based access, this web app empowers HRs and managers to efficiently oversee their teams and workflow.",
    image: require("./image4.png"),
    tags: ["React.js", "Node.js", "Express.js", "MongoDB", "Tailwind CSS"],
    category: "Web App",
    github: "https://github.com/champalalsuthar/WorkMate-Admin",
    webapp: "https://work-mate-admin.vercel.app/crm/login",
    Is_Live: true,
  },

  {
    id: 2,
    title: "VIRTUAL HELP",
    // date: "Jan 2024 - March 2024",
    description: "Developed a user-friendly web application for sharing notes and previous year’s question papers at the Central University of Haryana.Added modules like User login, upload notes, and post blogs.Implemented JWT Token-based User Authentication. Employed the bcrypt package algorithm to ensure the secure storage of passwords within the web application.Integrated Nodemailer, a powerful Node.js library, to implement email verification functionality. Added various operations like searching, deleting, updating, and CRUD operations",
    image: require("./image2.png"),
    tags: [
      "React.js", "Node.js", "MongoDB", "Firebase", "Express.js"
    ],
    category: "web app",
    github: "https://github.com/champalalsuthar/Virtual-Help-FrontEnd",
    webapp: "https://virtualhelp.vercel.app/",
    Is_Live: false,
  }

  // {
  //   id: 2,
  //   title: "",
  //   date: "",
  //   description:
  //     "",
  //   image:
  //     "",
  //   tags: [],
  //   category: "",
  //   github: "",
  //   webapp: "",
  //   member: [
  //     {
  //       name: "",
  //       img: "",
  //       linkedin: "",
  //       github: "",
  //     },
  //    {
  //       name: "",
  //       img: "",
  //       linkedin: "",
  //       github: "",
  //     },
  //   ],
  // },
];

export const TimeLineData = [
  { year: 2017, text: "" },
  { year: 2018, text: "" },
  { year: 2019, text: "" },
  { year: 2020, text: "" },
  { year: 2021, text: "" },
];
